export const campaignRunningStateMap: { [K in CampaignRunStateType]: string } = {
  NO_SCHEDULED_CAMPAIGN: 'No scheduled campaign',
  SCHEDULED_CAMPAIGN: 'Scheduled campaign',
  RUNNING_CAMPAIGN: 'Running campaign'
}
